export default __webpack_public_path__ + "cb5ad999740e9d8a8bd1b03b379293a9.woff2";